/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import OutlineButton from '../MUICustomButton/OutlineButton';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_CLIENT_CONTACT_REQUIRED, ERR_CLIENT_NAME_REQUIRED, ERR_EMAIL, ERR_EMAIL_INVALID, UNKNOWN_ERR } from 'src/constants/constant';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled, TextField } from '@mui/material';
import type { EditClientFormInputs, RootState } from '../types/types';
import GradientButton from '../MUICustomButton/GradientButton';
import SubClientList from './SubClientList';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getClientDetailsById, updateClientData } from 'src/services/clientService';
import { useNavigate } from 'react-router-dom';
import MUIModal from '../MUIModal/MUIModal';
import ClientConfigurationMapping from './ClientConfigurationMapping';
import Button from '../CustomButton/Button';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import moment from 'moment';
import { getESPConnectionData, getESPConnectionDataById } from 'src/services/emailAPIESPServices';
export interface PropsType {
    clientId?: string;
    clientData?: any;
    step?: string;
    onCancel: () => void;
}

const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(ERR_CLIENT_NAME_REQUIRED).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    clientContact: Yup.string().required(ERR_CLIENT_CONTACT_REQUIRED).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    // lastName: Yup.string().required(UPDATE_USER_ERROR_LAST_NAME).matches(/^[a-zA-Z0-9\s]*$/, NEW_USER_ERROR_INVALID_LAST_NAME),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    subscriptionStartDate: Yup.string().required("Please enter subscription start date")
            .test("valid-date", "Invalid date format", (value) =>
                moment(value, "YYYY-MM-DD", true).isValid()
            ),
        subscriptionEndDate: Yup.string().required("Please enter subscription end date").test("valid-date", "Invalid date format", (value) =>
            moment(value, "YYYY-MM-DD", true).isValid()
        )
            .test("endAfterStart", "Subscription end date must be after subscription start date", function (value) {
                const { subscriptionStartDate } = this.parent;
                return moment(value, "YYYY-MM-DD").isAfter(moment(subscriptionStartDate, "YYYY-MM-DD"));
            }),
    hldAccountManagerName: Yup.string().required("Please enter HLD account manager name").matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    hldAccountManagerEmail: Yup.string()
        .required("Please enter HLD account manager email")
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    subscriptionCampaignCount: Yup.number()
                                    .moreThan(1, "Number must be greater than 1")
                                    .lessThan(2147483647, "Number must be less than 2147483647")
                                    .test("is-integer", "Only whole numbers are allowed", (value) => Number.isInteger(value))
                                    .required("Please enter number of campaigns").typeError("Please enter valid number"),
    subscriptionEmailCount: Yup.number()
                                    .moreThan(1, "Number must be greater than 1")
                                    .lessThan(2147483647, "Number must be less than 2147483647")
                                    .test("is-integer", "Only whole numbers are allowed", (value) => Number.isInteger(value))
                                    .required("Please enter number of emails").typeError("Please enter valid number"),
    espConnectionId: Yup.string().required("Please select email service provider"),
    
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


function EditClientForm({ clientId, clientData, step, onCancel }: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [selectedClientData, setSelectedClientData] = useState<any>()
    const [showClientConfigurationModal, setShowClientConfigurationModal] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const [formValueUpdated, setFormValueUpdated] = useState<boolean>(false)
    const [openConfirmPopup, setOpenConfirmPopup] = useState<boolean>(false);
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const [showImportMappingModal, setShowImportMappingModal] = useState<boolean>(false);
    const [showExportMappingModal, setShowExportMappingModal] = useState<boolean>(false);

    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<EditClientFormInputs>({
        resolver: yupResolver(validationSchema),
        // defaultValues: {
        //     clientName: selectedClientData ? selectedClientData.clientName : clientData.clientName,
        //     clientContact: selectedClientData ? selectedClientData.clientContact : clientData.clientContact,
        //     email: selectedClientData ? selectedClientData.email : clientData.email
        // },
    });

    const getClientDetails = (): void => {
        setIsDataLoading(true)
        if (clientId) {
            getClientDetailsById(clientId).then(
                (res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            setSelectedClientData(res.data.data[0])
                            const clientDataArr: any = res.data.data[0]

                            setValue("clientName", clientDataArr.clientName)
                            setValue("clientContact", clientDataArr.clientContact)
                            setValue("email", clientDataArr.email)
                            setValue("hldAccountManagerName", clientDataArr.hldAccountManagerName)
                            setValue("hldAccountManagerEmail", clientDataArr.hldAccountManagerEmail)
                            setValue("subscriptionStartDate", clientDataArr.subscriptionStartDate ? moment(clientDataArr.subscriptionStartDate).add(1, 'days').format('YYYY-MM-DD') : '')
                            setValue("subscriptionEndDate", clientDataArr.subscriptionEndDate ? moment(clientDataArr.subscriptionEndDate).add(1, 'days').format('YYYY-MM-DD') : '')
                            setValue("subscriptionCampaignCount", clientDataArr.subscriptionCampaignCount)
                            setValue("subscriptionEmailCount", clientDataArr.subscriptionEmailCount)
                            setValue("espConnectionId", clientDataArr.espConnectionId ? clientDataArr.espConnectionId.toString() : "0")
                            setValue("espDomainName", clientDataArr.espDomainName)

                            getESPConnectionDataById(res.data.data[0].espConnectionId).then(
                                (res1: any) => {
                                    if (res1.status === 200) {
                                        if (res1.data.result === 1) {
                                            const connectionData = res1.data.data[0]
                                            
                                            setValue("domainName", connectionData.domain)
                                            setValue("fromEmailName", connectionData.fromName)
                                            setValue("fromEmailAddress", connectionData.fromEmail)
                                        }
                                    }
                                }
                            )
                            .catch(
                                (error) => console.log(error)
                            )
                        }

                    }
                }
            )
                .catch(
                    error => console.log("Error: ", error)
                )
                .finally(() => {
                    setIsDataLoading(false)
                })
        }

    }

    useEffect(() => {
        getClientDetails()
    }, [clientId, clientData])

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])


    const handleBackClick = (): void => {
        navigate('/settings/manage-clients')
    }



    const onSubmit = async (data: EditClientFormInputs): Promise<void> => {
        debugger
        console.log("TEST", data);
        setIsLoading(true)
        // data.id = clientData.id;
        // data.modifiedBy = user?.id;
        // data.parentId = clientData.parentId;
        // data.isActive = clientData.isActive ? clientData.isActive : true;

        const requestParams = {
            "id": clientData.id,
            "clientName": data.clientName,
            "email": data.email,
            "clientContact": data.clientContact,
            "parentId": clientData.parentId,
            "modifiedBy": user?.id,
            "hldAccountManagerName": data.hldAccountManagerName,
            "hldAccountManagerEmail": data.hldAccountManagerEmail,
            "subscriptionStartDate": moment(data.subscriptionStartDate),
            "subscriptionEndDate": moment(data.subscriptionEndDate),
            "subscriptionCampaignCount": data.subscriptionCampaignCount,
            "subscriptionEmailCount": data.subscriptionEmailCount,
            "espConnectionId": data.espConnectionId ? data.espConnectionId : 0,
            "espDomainName": data.espDomainName
        }

        try {
            debugger
            //@ts-ignore
            const res = await updateClientData(requestParams);
            
            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success(clientData.parentId === 0 ? "Client updated successfully" : "Sub-client updated successfully");

                    setTimeout(() => {
                        onCancel()
                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                   if(!errorMsg){                        
                     NotificationManager.error(res.data.messages); 
                     } else if(errorMsg.includes('Client name already exists')){
                        NotificationManager.error('Client name already exists');
                      } 
              }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
    }

    const handleFormReset = (): void => {
        onCancel()
    }

    const handleClientConfiguration = (): void => {
        setShowClientConfigurationModal(true)
    }

    const handleConfirmClose = (): void => {
        setOpenConfirmPopup(false)
    }
    const handleCloseClientConfiguration = (status: string | null = null): void => {
        if (status === null && formValueUpdated === true) {
            setOpenConfirmPopup(true)
        } else {
            setShowClientConfigurationModal(false)
        }
    }
    const handleFormValueUpdated = (value: boolean): void => {
        setFormValueUpdated(value)
    }
    const handleConfirmOpen = (): void => {
        setShowImportMappingModal(false)
        setShowExportMappingModal(false)
        setShowClientConfigurationModal(false)
        setFormValueUpdated(false)
        setOpenConfirmPopup(false)
    }

    console.log(formValueUpdated);

    

    return (
        <>
            <div >
                {
                    isDataLoading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                console.log('Form data:', errors);
                                void handleSubmit(onSubmit)(e);
                            }}
                        >
                            {
                                step === "1" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="clientName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label={"Client name*"}
                                                            autoComplete="off"
                                                            placeholder={"Client name*"}

                                                            error={Boolean(errors.clientName)}
                                                            helperText={errors.clientName?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="clientContact"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label={"Client contact*"}
                                                            autoComplete="off"
                                                            placeholder={"Client contact*"}

                                                            error={Boolean(errors.clientContact)}
                                                            helperText={errors.clientContact?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="Email*"
                                                            autoComplete="off"
                                                            placeholder="Email*"

                                                            error={Boolean(errors.email)}
                                                            helperText={errors.email?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="subscriptionStartDate"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        // <TextField
                                                        //     {...field}
                                                        //     fullWidth
                                                        //     label={parentId !== undefined ? "Sub-client contact*" : "Subscription Start Date"}
                                                        //     autoComplete="off"
                                                        //     placeholder={parentId !== undefined ? "Sub-client contact*" : "Subscription Start Date"}

                                                        //     error={Boolean(errors.clientContact)}
                                                        //     helperText={errors.clientContact?.message}
                                                        // />
                                                        <>
                                                            <div className="datepicker-container">
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DemoContainer components={['DatePicker']}>
                                                                        <DatePicker
                                                                            label="Subscription Start Date*"
                                                                            value={field.value ? moment(field.value) : null}
                                                                            onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                                            minDate={moment()} // Use moment for minDate
                                                                            format="MM/DD/YYYY"
                                                                            slotProps={{
                                                                                textField: ({ position }) => ({
                                                                                    error: errors.subscriptionStartDate && Boolean(errors.subscriptionStartDate), helperText: errors.subscriptionStartDate?.message
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </DemoContainer>
                                                                </LocalizationProvider>
                                                            </div>

                                                        </>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="subscriptionEndDate"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <>
                                                            <div className="datepicker-container">
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DemoContainer components={['DatePicker']}>
                                                                        <DatePicker
                                                                            label="Subscription End Date*"
                                                                            onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                                            value={field.value ? moment(field.value) : null}
                                                                            minDate={moment()} // Use moment for minDate
                                                                            format="MM/DD/YYYY"
                                                                            slotProps={{
                                                                                textField: ({ position }) => ({
                                                                                    error: errors.subscriptionEndDate && Boolean(errors.subscriptionEndDate), helperText: errors.subscriptionEndDate?.message
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </DemoContainer>
                                                                </LocalizationProvider>
                                                            </div>

                                                        </>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="hldAccountManagerName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label={"HLD Account Manager Name*"}
                                                            autoComplete="off"
                                                            placeholder={"HLD Account Manager Name*"}

                                                            error={Boolean(errors.hldAccountManagerName)}
                                                            helperText={errors.hldAccountManagerName?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="hldAccountManagerEmail"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="HLD Account Manager Notifications*"
                                                            autoComplete="off"
                                                            placeholder="HLD Account Manager Notifications*"

                                                            error={Boolean(errors.hldAccountManagerEmail)}
                                                            helperText={errors.hldAccountManagerEmail?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {
                                step === "2" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="espConnectionId"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            options={espConnectionData} // The list of clients
                                                            getOptionLabel={(option: any) => option.connectionName} // Use clientName for display
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            //@ts-ignore
                                                            isOptionEqualToValue={(option, value) => option.id === value} // Match by ID
                                                            value={espConnectionData.find((esp: any) => esp.id === field.value)} // Match current value
                                                            onChange={(_, selectedConnection) => {
                                                                // const clientId = selectedClient?.id; // Handle null case
                                                                // console.log('Selected client:', clientId);
                                                                // handleClientClick(Number(clientId)); // Trigger your client click handler
                                                                field.onChange(selectedConnection.id); // Update the form state
                                                                setValue("espDomainName", selectedConnection.domain)
                                                                setValue("fromEmailName", selectedConnection.fromName)
                                                                setValue("fromEmailAddress", selectedConnection.fromEmail)
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Email Service Provider*"
                                                                    placeholder="Select Email Service Provider"
                                                                    error={Boolean(errors.espConnectionId)}
                                                                    helperText={errors.espConnectionId?.message}
                                                                />
                                                            )}
                                                            disableClearable // Prevent the clear button
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="espDomainName"
                                                    control={control}
                                                    defaultValue=''
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="Domain Name"
                                                            autoComplete="off"
                                                            placeholder="Domain Name"
                                                            disabled

                                                            error={Boolean(errors.espDomainName)}
                                                            helperText={errors.espDomainName?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromEmailName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label={"From Email Name"}
                                                            autoComplete="off"
                                                            placeholder={"From Email Name"}
                                                            disabled

                                                            error={Boolean(errors.fromEmailName)}
                                                            helperText={errors.fromEmailName?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromEmailAddress"
                                                    defaultValue=""
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="From Email Address"
                                                            autoComplete="off"
                                                            placeholder="From Email Address"
                                                            disabled

                                                            error={Boolean(errors.fromEmailAddress)}
                                                            helperText={errors.fromEmailAddress?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {
                                step === "3" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="subscriptionCampaignCount"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            // type='number'
                                                            fullWidth
                                                            label={"# of Campaigns*"}
                                                            autoComplete="off"
                                                            placeholder={"# of Campaigns*"}

                                                            error={Boolean(errors.subscriptionCampaignCount)}
                                                            helperText={errors.subscriptionCampaignCount?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="subscriptionEmailCount"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            // type='number'
                                                            label="# of Emails*"
                                                            autoComplete="off"
                                                            placeholder="# of Emails*"

                                                            error={Boolean(errors.subscriptionEmailCount)}
                                                            helperText={errors.subscriptionEmailCount?.message}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            <div className='flex gap-2 justify-end'>
                                <OutlineButton color='gray' onClick={() => handleFormReset()} width='130px'>Cancel</OutlineButton>
                                <GradientButton type='submit' color='red' onClick={handleFormReset} width='130px'>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                            </div>

                        </form>
                }
            </div>
            <MUIModal title="Client Configuration" openModal={showClientConfigurationModal} closeModal={handleCloseClientConfiguration} >
                <ClientConfigurationMapping clientId={clientId as unknown as number} clientName={clientData?.clientName} formValueUpdated={handleFormValueUpdated} closeModal={handleCloseClientConfiguration} />
            </MUIModal>
            <BootstrapDialog
                onClose={handleConfirmClose}
                aria-labelledby="customized-dialog-title"
                open={openConfirmPopup}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    Review changes
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleConfirmClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                   <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{`You haven't saved your changes. Are you sure you want to leave the page?`}</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    {/* <Button isGradient color="primary" label="Update" onClick={handleAssigneeClose} /> */}
                    <Button btntype={"button"} onClick={handleConfirmClose} label={"Cancel"} type={'default'} size={'small'} disabled={isModalSaveLoading}></Button>
                    <Button btntype="submit" label={!isModalSaveLoading ? "Discard" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleConfirmOpen} disabled={isModalSaveLoading}></Button>

                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default EditClientForm